import { render, staticRenderFns } from "./cross.vue?vue&type=template&id=f601108c&scoped=true&"
var script = {}
import style0 from "./cross.vue?vue&type=style&index=0&id=f601108c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f601108c",
  null
  
)

export default component.exports